import { render, staticRenderFns } from "./configuration.view.vue?vue&type=template&id=62543e94&scoped=true&"
import script from "./configuration.view.vue?vue&type=script&lang=ts&"
export * from "./configuration.view.vue?vue&type=script&lang=ts&"
import style0 from "./configuration.view.vue?vue&type=style&index=0&id=62543e94&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62543e94",
  null
  
)

export default component.exports